<template>
    <Head title="Search Local Jobs" />
    <div class="bg-white">

      <div class="flex flex-1 items-center justify-center">
        <div class="relative w-full max-w-md md:max-w-4xl pt-12 xl:pt-24">
          <!-- <div
            class="invisible dark:visible absolute inset-0 bg-blue-600 rounded-md blur opacity-50"
          ></div> -->
          <div
            class="relative p-8 shadosw-lg rounded-md space-y-3"
          >
          <p class="text-gray-500 float-right text-sm tracking-wider">More than <strong class="text-lg italic text-blue-500">{{ totalLocalJobs }}</strong> Local jobs</p>
            <div class="flex flex-col justify-start py-3 w-full">
                <h1 class="text-5xl font-bold text-blue-600">CDL Local Jobs</h1>
                <h1 class="text-xl font-bold text-red-500">All You Need is a Zip code</h1>
            </div>

            <form
              v-if="isAgent"
              @submit.prevent="searchById"
              class="border-b pb-8 mb-8"
            >
              <div class="mt-4">
                <label for="jobId" class="sr-only">Job ID</label>
                <input
                  type="text"
                  name="jobId"
                  id="jobId"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-md"
                  :class="
                    jobSearchForm.errors.jobId
                      ? 'border-red-400'
                      : 'border-gray-300'
                  "
                  placeholder="Enter the Job ID"
                  v-model="jobSearchForm.jobId"
                  required
                />
                <p
                  v-if="jobSearchForm.errors.jobId"
                  class="mt-1 ml-2 text-sm text-red-600"
                  v-text="jobSearchForm.errors.jobId"
                ></p>
              </div>

              <div class="mt-4">
                <button
                  class="flex items-center justify-center w-full py-3 bg-green-600 hover:bg-green-500 text-white text-sm font-medium rounded disabled:bg-green-400 disabled:cursor-not-allowed"
                  :disabled="jobSearchForm.processing"
                >
                  <svg
                    v-show="jobSearchForm.processing"
                    class="animate-spin mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Search</span>
                </button>
              </div>
            </form>

            <form @submit.prevent="submit">
              <div class="space-y-7">
                <label for="zipcode" class="sr-only">Zip Code</label>
                <input
                  type="text"
                  name="zipcode"
                  ref="zipCodeInput"
                  id="zipcode"
                  class="p-6 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm rounded-full"
                  :class="
                    form.errors.zipcode ? 'border-red-400' : 'border-gray-300'
                  "
                  placeholder="Enter Your Zip Code"
                  v-model="form.zipcode"
                  required
                />
                <p
                  v-if="form.errors.zipcode"
                  class="mt-1 ml-2 text-sm text-red-600"
                  v-text="form.errors.zipcode"
                ></p>
              </div>

              <div class="mt-4 py-7">
                <div class="grid grid-cols-2 gap-4">
                  <div>
                    <label
                      for="cdl"
                      class="block text-sm font-medium text-gray-400 tracking-wider ml-4 shadow-2xl"
                      >CDL Class</label
                    >
                    <select
                      id="cdl"
                      name="cdl"
                      class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-full"
                      @change="form.cdl_class = $event.target.value"
                    >
                      <option
                        v-for="cdl_class in cdl_classes"
                        :key="cdl_class.value"
                        :value="cdl_class.value"
                        :selected="cdl_class.value === form.cdl_class"
                      >
                        {{ cdl_class.label }}
                      </option>
                    </select>
                  </div>
                  <div class="relative flex items-start pt-7">
                    <div class="flex items-center h-5">
                      <input
                        id="sap"
                        type="checkbox"
                        class="focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300 rounded"
                        name="sap"
                        value="1"
                        v-model="form.sap_only"
                      />
                    </div>
                    <div class="ml-3 text-sm">
                      <label
                        for="sap"
                        class="text-sm font-medium text-gray-700"
                        >SAP Jobs Only</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="mt-8">
                <button
                  class="flex items-center justify-center w-1/4 py-3 bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium rounded-full disabled:bg-green-400 disabled:cursor-not-allowed"
                  :disabled="form.processing"
                >
                  <svg
                    v-show="form.processing"
                    class="animate-spin mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      class="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      stroke-width="4"
                    ></circle>
                    <path
                      class="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  <span>Get Jobs</span>
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>

    </div>
  </template>

  <script>
  import { Link, Head, useForm } from "@inertiajs/inertia-vue3";
  import { computed, watch, ref, onMounted } from "vue";
  import debounce from "lodash/debounce";
  import { RefreshIcon } from "@heroicons/vue/solid";
  import AppFooter from "@/components/Layouts/Footer";
  import ProfileDropdown from "@/components/ProfileDropdown";

  export default {
    props: {
      ourJobs: Number,
      feedJobs: Number,
      auth: Object,
    },

    setup(props) {
      const route = window.route;
      const zipCodeInput = ref(null);

      onMounted(() => {
        zipCodeInput.value.focus()
      })

      const url = new URLSearchParams(window.location.search);

      const cdl_classes = [
        { value: "a", label: "CDL A" },
        { value: "b", label: "CDL B" },
      ];

      const form = useForm({
        zipcode: "",
        cdl_class: "a",
        job_type: "local",
        // owner_operator: false,
        sap_only: url.get("sap_only") == 1,
      });

      const jobSearchForm = useForm({
        jobId: "",
      });

      const totalLocalJobs = computed(() => props.ourJobs + props.feedJobs);

      const zipcode = computed(() => form.zipcode);

      const isAgent = computed(
          () =>
              props.auth &&
              (props.auth.role.includes("agent") ||
                  props.auth.role.includes(
                      "Restricted Agent to companies US Xpress, Heartland and DB Schenker"
                  ))
      );


      watch(
        zipcode,
        debounce(
          (val) => {
            if (form.errors.zipcode) {
              form.clearErrors("zipcode");
            }
          },
          250,
          true
        )
      );

      function submit() {
        form.post("/search");
      }

      function searchById() {
        jobSearchForm.post(route("jobs.search-by-id"));
      }

      return {
        form,
        route,
        submit,
        isAgent,
        searchById,
        cdl_classes,
        jobSearchForm,
        zipCodeInput,
        totalLocalJobs,
      };
    },

    // mounted(){
    //     console.log("mounted....")
    //     this.zipCodeInput.value.focus();
    // },

    components: {
      Head,
      AppFooter,
      RefreshIcon,
      Link,
      ProfileDropdown,

    },
  };
  </script>
